import { defineMessages, FormattedMessage } from "react-intl";

import { Text } from "@ps-design-system/components/Text";
import { TextareaField } from "@ps-design-system/components/Textarea";

import { useIntl } from "react-intl-compat";

const DO_NOT_INCLUDE_ITEMS = defineMessages({
  cleaningFeeLabel: {
    id: "hosting.space_rules.cleaning_fee_label",
    defaultMessage: "Cleaning Fee",
  },
  cleaningFeeDetails: {
    id: "hosting.space_rules.cleaning_fee_details",
    defaultMessage:
      "Basic cleaning is the responsibility of the host. If you charge a cleaning fee, you can add it in a later section.",
  },
  contractsLabel: {
    id: "hosting.space_rules.contracts_label",
    defaultMessage: "Contracts",
  },
});

const GeneralRulesField = () => {
  const intl = useIntl();

  return (
    <div className="tw-flex tw-flex-col tw-gap-16">
      <div className="tw-flex tw-flex-col tw-gap-8">
        <Text typeface="headline-4-b" element="h2" className="tw-m-0">
          <FormattedMessage
            id="hosting.space_rules.rules_header"
            defaultMessage="What are your house rules?"
          />
        </Text>
        <Text typeface="body-2" element="p" className="tw-m-0">
          <FormattedMessage
            id="hosting.space_rules.rules_subheader"
            defaultMessage="Include any rules about what your guests can and cannot do in the space."
          />
        </Text>
      </div>

      <div>
        <Text typeface="body-2-m">
          <FormattedMessage
            id="hosting.space_rules.example_rules_header"
            defaultMessage="Example rules:"
          />
        </Text>
        <ul className="tw-list-disc tw-list-inside tw-m-0">
          <Text element="li">
            <FormattedMessage
              id="hosting.space_rules.rules_example_smoking"
              defaultMessage="No smoking in the building"
            />
          </Text>
          <Text element="li">
            <FormattedMessage
              id="hosting.space_rules.rules_example_catering"
              defaultMessage="Outside catering is allowed"
            />
          </Text>
          <Text element="li">
            <FormattedMessage
              id="hosting.space_rules.rules_example_alcohol"
              defaultMessage="No alcohol allowed after 8pm"
            />
          </Text>
        </ul>
      </div>

      <div>
        <Text typeface="body-2-m">
          <FormattedMessage
            id="hosting.space_rules.do_not_include"
            defaultMessage="Do not include:"
          />
        </Text>
        <ul className="tw-list-disc tw-list-inside tw-m-0">
          <Text element="li">
            <Text typeface="body-2-m">
              <FormattedMessage {...DO_NOT_INCLUDE_ITEMS.cleaningFeeLabel} />
            </Text>
            {" - "}
            <Text typeface="body-2">
              <FormattedMessage {...DO_NOT_INCLUDE_ITEMS.cleaningFeeDetails} />
            </Text>
          </Text>
          <Text element="li">
            <Text typeface="body-2-m">
              <FormattedMessage {...DO_NOT_INCLUDE_ITEMS.contractsLabel} />
            </Text>
            {" - "}
            <Text typeface="body-2">
              <FormattedMessage
                id="hosting.space_rules.contracts_details"
                defaultMessage="Peerspace bookings are covered by our {serviceAgreementLink}. Do not paste your contract, cancellation policy, or liability policy."
                values={{
                  serviceAgreementLink: (
                    <Text
                      element="a"
                      href="https://www.peerspace.com/legal/terms"
                      target="_blank"
                      rel="noreferrer"
                      className="tw-underline"
                    >
                      <FormattedMessage
                        id="hosting.space_rules.service_agreement"
                        defaultMessage="Service Agreement"
                      />
                    </Text>
                  ),
                }}
              />
            </Text>
          </Text>
        </ul>
      </div>

      <TextareaField
        fullWidth
        name="rules"
        placeholder={intl.formatMessage({
          id: "hosting.space_rules.rules_placeholder",
          defaultMessage: "Enter your house rules",
        })}
        note={intl.formatMessage({
          id: "hosting.space_rules.rules_char_min",
          defaultMessage: "Minimum 100 characters",
        })}
        testId="space-rules-form-rules-input"
      />
    </div>
  );
};

export { GeneralRulesField };
